import React, { useState } from 'react';
import { useEffect } from 'react'; 
import { useForm } from 'react-hook-form';
import {
  ColTitle,
  ErrorMsg,
  Form,
  Label,
  RRow,
} from './Register.style';
import FW from '../../config/word.json';
import MainLayout from '../../components/Layouts/Main/MainLayout.index.js';
import {getUser} from "../../api/project";
import { useLocation } from 'react-router-dom';
import { updateUserFromWeb } from "../../api/project";
import { toast } from 'react-toastify';


function REGISTER(props) {

    const query = new URLSearchParams(useLocation().search);
    const userId = query.get('userId');

    const { register, handleSubmit, reset, formState: { errors }, } = useForm();
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const onSubmit = async (data) => {
        try {
            const jUser = {
                userId: data.userId,
                userFlg: data.userFlg,
                groupName: data.groupName,
                imageUrl: data.imageUrl,
                maxSendAdCnt: data.maxSendAdCnt,
            };
            const response = await updateUserFromWeb(jUser);
            if (response.code === 200) {
                toast.success('更新に成功しました！');
                //navigate('/home');
            }
        } catch (error) {
            setIsError(true);
            setErrorMessage(error.response?.data?.message || '更新に失敗しました');
        }
    };

  // ✅ 初期表示時にAPIからデータ取得
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!userId) return;
        const res = await getUser(userId);
        const data = res.data;
        const formData = {
          userId: data.userId || '',
          twitterName: data.twitterName || '',
          userName: data.userName || '',
          userKana: data.userKana || '',
          userFlg: data.userFlg?.toString() || '1',
          groupName: data.groupName || '',
          searchKeyword: data.searchKeyWord || '',
          selfIntroduction: data.selfIntroduction || '',
          email: data.email || '',
          birthday: data.birthday || '',
          tel: data.tel || '',
          imageUrl: data.imageUrl || '',
          authFlg: (data.authFlg?.toString() || '0') !=='1' ? '0' : '1',
          cancelFlg: data.cancelFlg?.toString() || '0',
          maxSendAdCnt: data.maxSendAdCnt || '',
        };

        reset(formData);
      } catch (error) {
        console.error('初期データ取得失敗:', error);
        setIsError(true);
        setErrorMessage('初期データの取得に失敗しました');
      }
    };

    fetchData();
  }, [reset, userId]);

  return (
    <MainLayout>
      <div style={{ marginBottom: '10px', marginTop: '10px',　textAlign: 'left', color: '#00C6BB'}}>
        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
        推しごとカレンダーからユーザー情報詳細
        </span>
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        
        {/* ユーザID */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_N}</ColTitle>
          <span>
            <input
              type="text"
              {...register('userId')}
              aria-label="userId"
              disabled
            />
          </span>
          {errors.userId && <ErrorMsg>{errors.userId.message}</ErrorMsg>}
        </RRow>

        {/* Xユーザ名 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_TWITTER_NAME}</ColTitle>
          <span>
            <input
              type="text"
              {...register('twitterName')}
              aria-label="twitterName"
              disabled
            />
          </span>
          {errors.twitterName && <ErrorMsg>{errors.twitterName.message}</ErrorMsg>}
        </RRow>

        {/* ユーザ名 */}
        <RRow>
        <ColTitle>{FW.F_W_SYS_USER_NAME}</ColTitle>
        <span>
            <input
            type="text"
            {...register('userName')}
            placeholder={FW.F_W_SYS_USER_NAME}
            aria-label="userName"
            disabled
            />
        </span>
        {errors.twitterName && <ErrorMsg>{errors.twitterName.message}</ErrorMsg>}
        </RRow>

        {/* ユーザ仮名 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_KANA}</ColTitle>
          <span>
            <input
              type="text"
              {...register('userKana')}
              aria-label="userKana"
              disabled
            />
          </span>
          {errors.userKana && <ErrorMsg>{errors.userKana.message}</ErrorMsg>}
        </RRow>

        {/* ユーザ種類 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_USER_FLG}</ColTitle>
          <span>
            <input
              type="radio"
              value="1"
              {...register('userFlg')}
              defaultChecked
            />
            <Label htmlFor="pro">{FW.F_W_SYS_USER_FLG_PRO}</Label>
            <input
              type="radio"
              value="2"
              {...register('userFlg')}
            />
            <Label htmlFor="custom">{FW.F_W_SYS_USER_FLG_CUSTOM}</Label>
            <input
              type="radio"
              value="3"
              {...register('userFlg')}
            />
            <Label htmlFor="custom">{FW.F_W_SYS_USER_FLG_JYANSOU}</Label>
            <input
              type="radio"
              value="4"
              {...register('userFlg')}
            />
            <Label htmlFor="custom">{FW.F_W_SYS_USER_FLG_JYANBAR}</Label>
          </span>
          {errors.userFlg && <ErrorMsg>{errors.userFlg.message}</ErrorMsg>}
        </RRow>

        {/* 所属団体 */}
        <RRow>
        <ColTitle>{FW.F_W_SYS_GROUP_NAME}</ColTitle>
        <span>
            <select
            {...register('groupName')}
            aria-label="groupName"
            defaultValue=""
            size={12}
            >
            <option value="" disabled>
                {FW.F_W_SYS_GROUP_NAME}を選択
            </option>
            <option value="所属団体(未選択)">所属団体(未選択)</option>
            <option value="日本プロ麻雀連盟">日本プロ麻雀連盟</option>
            <option value="最高位戦日本プロ麻雀協会">最高位戦日本プロ麻雀協会</option>
            <option value="日本プロ麻雀協会">日本プロ麻雀協会</option>
            <option value="RMU">RMU</option>
            <option value="麻将連合">麻将連合</option>
            <option value="雀荘">雀荘</option>
            <option value="麻雀BAR">麻雀BAR</option>
            <option value="ザンリーグ">ザンリーグ</option>
            <option value="その他">その他</option>
            </select>
        </span>
        {errors.groupName && <ErrorMsg>{errors.groupName.message}</ErrorMsg>}
        </RRow>

        {/* 検索キーワード */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_SEARCH_KEYWORD}</ColTitle>
          <span>
            <input
              type="text"
              {...register('searchKeyword')}
              placeholder={FW.F_W_SYS_SEARCH_KEYWORD}
              aria-label="searchKeyword"
              disabled
            />
          </span>
        </RRow>

        {/* 自己紹介 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_SELF_INTRODUCTION}</ColTitle>
          <span>
            <textarea
              {...register('selfIntroduction')}
              placeholder={FW.F_S_P_SELF_INTRODUCTION}
              aria-label="selfIntroduction"
              rows={3}
              cols={45}
              disabled
            />
          </span>
        </RRow>

        {/* メールアドレス */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_E}</ColTitle>
          <span>
            <input
              type="email"
              {...register('email')}
              placeholder={FW.F_W_SYS_E}
              aria-label="email"
              disabled
            />
          </span>
          {errors.email && <ErrorMsg>{errors.email.message}</ErrorMsg>}
        </RRow>

        {/* 生年月日 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_B}</ColTitle>
          <span>
            <input
              type="text"
              {...register('birthday')}
              disabled
            />
          </span>
          {errors.birthday && <ErrorMsg>{errors.birthday.message}</ErrorMsg>}
        </RRow>

        {/* 電話番号 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_TEL}</ColTitle>
          <span>
            <input
              type="tel"
              {...register('tel')}
              placeholder={FW.F_W_SYS_TEL}
              aria-label="tel"
              disabled
            />
          </span>
          {errors.tel && <ErrorMsg>{errors.tel.message}</ErrorMsg>}
        </RRow>

        {/* 画像URL */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_IMAGE_URL}</ColTitle>
          <span>
            <input
              type="url"
              {...register('imageUrl')}
              placeholder={FW.F_S_P_IMAGE_URL}
              aria-label="imageUrl"
            />
          </span>
        </RRow>

        {/* 認証flg */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_AUTH_FLG}</ColTitle>
          <span>
            <input
              type="radio"
              value="0"
              {...register('authFlg')}
              defaultChecked
              disabled
            />
            <Label htmlFor="auth0">{FW.F_W_SYS_AUTH_FLG_UNAUTH}</Label>
            <input
              type="radio"
              value="2"
              {...register('authFlg')}
              disabled
            />
            <Label htmlFor="auth0">{FW.F_W_SYS_AUTH_FLG_2}</Label>
            <input
              type="radio"
              value="3"
              {...register('authFlg')}
              disabled
            />
            <Label htmlFor="auth0">{FW.F_W_SYS_AUTH_FLG_3}</Label>
            <input
              type="radio"
              value="1"
              {...register('authFlg')}
              disabled
            />
            <Label htmlFor="auth1">{FW.F_W_SYS_AUTH_FLG_AUTH}</Label>
          </span>
          {errors.authFlg && <ErrorMsg>{errors.authFlg.message}</ErrorMsg>}
        </RRow>

        {/* 退会flg */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_CANCEL_FLG}</ColTitle>
          <span>
            <input
              type="radio"
              value="0"
              {...register('cancelFlg')}
              defaultChecked
              disabled
            />
            <Label htmlFor="cancel0">{FW.F_W_SYS_CANCEL_FLG_ACTIVE}</Label>
            <input
              type="radio"
              value="1"
              {...register('cancelFlg')}
              disabled
            />
            <Label htmlFor="cancel1">{FW.F_W_SYS_CANCEL_FLG_CANCELLED}</Label>
          </span>
          {errors.cancelFlg && <ErrorMsg>{errors.cancelFlg.message}</ErrorMsg>}
        </RRow>

        {/* 最大広告送信数 Push通知 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_Push_MAX_CNT}</ColTitle>
          <span>
            <input
              type="text"
              {...register('maxSendAdCnt')}
              style={{ textAlign: 'right' }}
              placeholder={FW.F_W_SYS_Push_MAX_CNT}
              aria-label="maxSendAdCnt"
            />
          </span>
          {errors.maxSendAdCnt && <ErrorMsg>{errors.maxSendAdCnt.message}</ErrorMsg>}
        </RRow>

        {/* レコード作成日時 */}
        {/* 自動設定されるので入力不要 */}

        {/* レコード更新日時 */}
        {/* 自動設定されるので入力不要 */}

        <div className='foot'>
          <input type="submit" value={FW.F_W_REGISTER_REGISTER} aria-label="submit" />
        </div>

        {isError && <ErrorMsg>{errorMessage}</ErrorMsg>}
        <div style={{ height: '100px' }} />
      </Form>
    </MainLayout>
  );
}

export default REGISTER;
